import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { authInterceptorFn, AuthModule } from '@plugins/client/auth';
import { JsonDateModule } from '@plugins/client/json-date';
import { MultilanguageService } from '@plugins/client/multilanguage/multilanguage.service';
import { LANGUAGES } from '@plugins/client/routing/app.guard';
import { APP_VERSION } from '@plugins/client/tokens/app-version.token';
import { localeIdProvider } from '@plugins/client/translate/providers';
import { MiddlewareSdkModule } from '@plugins/middleware-sdk';

import { environment } from '../environments/environment';

import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes, withComponentInputBinding()),
    provideAnimations(),
    provideHttpClient(withInterceptors([authInterceptorFn])),
    importProvidersFrom(MiddlewareSdkModule),
    importProvidersFrom(AuthModule.forRoot()),
    MultilanguageService,
    importProvidersFrom(JsonDateModule.configure({ paths: ['/api/'] })),
    localeIdProvider(environment.languages),
    { provide: LANGUAGES, useValue: environment.languages },
    { provide: APP_VERSION, useValue: environment.appVersion },
  ],
};
